import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BodyImgService {

  // region Atributos
  private API_URL = environment.url;
  // endregion

  // region Constructor
  constructor(private httpClient: HttpClient) {}
  // endregion

  //#region Métodos

  // Obtiene el listado de grupos
  getUserBodyImgs(iduser): Observable<any> {
    return this.httpClient.get(`${this.API_URL}/body_images_by_user/${iduser}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  saveComment(idbody, data): Observable<any> {
    return this.httpClient.post(`${this.API_URL}/body_images_by_user/comment/${idbody}`, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
